// extracted by mini-css-extract-plugin
export default {"container":"created-order_container__20vT+"};